import { Field, Form, Formik, FormikHelpers } from "formik";
import { Col, Row } from "reactstrap";
import styles from "src/components/Common/UI/MultiStepWizard/MultiStepWizard.module.css";
import { useGetAllNodes } from "src/pages/Configuration/LinesAndNodesConfiguration/Nodes/api/getAllNodes";
import * as Yup from "yup";

const EstablishmentNodeForm: React.FC<StepProps> = ({
  initialValues,
  onSubmit,
}) => {

  const getAllNodesQuery = useGetAllNodes({data: undefined});

  
  const WizardSchema = Yup.object().shape({
    nodeID: Yup.string().required("Το πεδίο είναι υποχρεωτικό"),
  });

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={WizardSchema}
        onSubmit={onSubmit}
        enableReinitialize={true}
      >
        {({ errors, touched }) => (
          <Form>
            <Row>
              <Col xs={3}>
                <div className="flex-grow-1">
                  <label className="form-label">{"Κόμβος"}</label>
                </div>
                <div className="mb-3">
                  <Field 
                    as="select" 
                    name="nodeID" 
                    className="form-control"
                    >
                    <option value={""}>Επιλέξτε Κόμβο</option>
                    {getAllNodesQuery.data &&
                      getAllNodesQuery.data.map((node) => (
                      <option key={node.id} value={node.id}>
                        {node.description}
                      </option>
                    ))}
                  </Field>
                  <div className="text-danger">
                    {errors.nodeID && touched.nodeID && (
                      <div>{errors.nodeID as string}</div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <button type="submit" className={styles.buttonnext}>
              Συνέχεια
            </button>
          </Form>
        )}
      </Formik>
    </>
  );
};

interface StepProps {
  type: "create" | "edit";
  initialValues: IEstablishmentNodeForm;
  onSubmit: (
    values: IEstablishmentNodeForm,
    formikHelpers: FormikHelpers<IEstablishmentNodeForm>
  ) => void;
}

export default EstablishmentNodeForm;
